import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { endpoints } from 'src/app/constant/endpoints';
import { ApiService } from 'src/app/provider/api.service';
import _ from 'lodash';

@Component({
    selector: 'app-aboutus',
    templateUrl: './aboutus.page.html',
    styleUrls: ['./aboutus.page.scss'],
})
export class AboutusPage implements OnInit {
    content: any;
    constructor(
        public modalCtrl: ModalController,
        private apiService: ApiService
    ) { }
    ngOnInit() {
        this.apiService.
            get(endpoints.cms)
            .subscribe((res) => {
                console.log(res);
                this.content = _.filter(res.data.pages, (val) => val.title == "About Us")[0].content;
                //console.log(this.content);
            });
    }

    closeModal = () => {
        this.modalCtrl.dismiss();
    }

}
